module.exports = "/_next/static/images/hardhat-duotone-ade1eb0256cbea05ae43258c1acd7e46.svg";